import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { CustomButton } from '../../../v2/MUI_custom_component';
import IconReusable from '../../../components/IconReusable';
import { useSelector } from 'react-redux';

const ClubCard = ({ 
  club, 
  onActionClick, 
  actionButtonLabel = "Create PO",
  showActionButton = true 
}) => {
  const WHITE_KEYS = ['gold', 'bronze', 'titanium', 'silver'];
  const { is_PWA } = useSelector((state) => {
        return {
            is_PWA: state.loginReducer.is_PWA,
        };
    });
  
  const isWhiteTextCard = (title) => {
    const t = title?.toLowerCase() || '';
    return WHITE_KEYS.some(key => t.includes(key));
  };

  const isWhite = isWhiteTextCard(club.title);
  const textColor = isWhite ? '#fff' : '#333';
  const secondaryTextColor = isWhite ? '#fff' : '#666';

  const handleActionClick = () => {
    if (onActionClick) {
      onActionClick(club);
    }
  };
  const showHistory = useSelector(state => state.entityReducer.show_history);
  return (
    <Grid item xs={12}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box
          sx={{
            backgroundImage: `url(${club.card_url})`,
            borderRadius: 2,
            p: 2,
            backgroundPosition: 'left top',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            color: textColor,
            position: 'relative',
            overflow: 'hidden',

            '@keyframes shine': {
                '0%': {
                    transform: 'translateX(-150%) translateY(150%) rotate(-45deg)',
                    opacity: 0,
                },
                '10%': {
                    opacity: 0.4,
                },
                '25%': {
                    opacity: 0.8,
                },
                '40%': {
                    opacity: 0.4,
                },
                '50%': {
                    transform: 'translateX(250%) translateY(-150%) rotate(-45deg)',
                    opacity: 0,
                },
                '60%': {
                    opacity: 0.4,
                },
                '75%': {
                    opacity: 0.8,
                },
                '90%': {
                    opacity: 0.4,
                },
                '100%': {
                    transform: 'translateX(-150%) translateY(150%) rotate(-45deg)',
                    opacity: 0,
                },
            },

            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '18px',
                height: '800%',
                background: `linear-gradient(
                    45deg,
                    rgba(255, 255, 255, 0) 0%,
                    rgba(255, 255, 255, 0.4) 25%,
                    rgba(255, 255, 255, 0.8) 50%,
                    rgba(255, 255, 255, 0.4) 75%,
                    rgba(255, 255, 255, 0) 100%
                )`,
                animation: 'shine 15s ease-in-out infinite',
                zIndex: 1,
            },
            '& > *': {
                position: 'relative',
                zIndex: 2,
            },
          }}
        >
          {/* HEADER */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            {club.logo && <Box component="img" src={club.logo} alt={`${club.title} logo`} />}
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  color: 'inherit',
                }}
                variant='h1'
              >
                {club.title}
              </Typography>

              {club.subtitle && (
                <Typography
                  variant="p3"
                  sx={{ color: secondaryTextColor }}
                >
                  {club.subtitle}
                </Typography>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              pb: 1,
            }}
          >
            {club.firm_name && (
              <Typography
                sx={{
                //   fontWeight: 'bold',
                //   fontSize: '20px',
                //   lineHeight: '32px',
                  color: 'inherit',
                }}
                variant='h2'
              >
                {club.firm_name}
              </Typography>
            )}
            {club.sales_info && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  pt: 1,
                  borderTop: isWhite
                    ? '1px solid rgba(255,255,255,0.3)'
                    : '1px solid #D9D9D9',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <IconReusable
                    name="InfoOutlined"
                    size={20}
                    color={textColor}
                  />

                  <Typography variant="labelM" sx={{ color: 'inherit' }}>
                    {club.sales_info.display_name}
                  </Typography>
                </Box>

                <Typography variant="p3" sx={{ color: 'inherit' }}>
                  {club.sales_info.value}
                </Typography>
              </Box>
            )}
            {club.validity && (
              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: '160px' }}>
                  <Typography variant="labelM" sx={{ color: 'inherit' }}>
                    Club Valid from
                  </Typography>

                  <Typography variant="p3" sx={{ color: 'inherit' }}>
                    {club.validity.valid_from}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="labelM" sx={{ color: 'inherit' }}>
                    Valid to
                  </Typography>

                  <Typography variant="p3" sx={{ color: 'inherit' }}>
                    {club.validity.valid_to}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
        {showActionButton && !is_PWA && (
          <CustomButton
            variant="outlined"
            size="small"
            label={actionButtonLabel}
            onClick={handleActionClick}
            disabled={showHistory}
          />
        )}
      </Box>
    </Grid>
  );
};

export default ClubCard;